import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../../core/modules/shared.module';
import { RouterModule } from '@angular/router';

import { FuseLogin2Component } from './login-2.component';

const routes = [
    {
        path: 'pages/auth/login-2',
        component: FuseLogin2Component
    }
];

@NgModule({
    declarations: [
        FuseLogin2Component
    ],
    imports: [
        SharedModule,
        RouterModule.forChild(routes)
    ],
    providers: [
    ]
})

export class Login2Module {

}



// WEBPACK FOOTER //
// ./src/app/main/content/pages/authentication/login-2/login-2.module.ts